import {
    useFormIsIngredientRemoved,
    useFormUnregisterField,
} from '@/features/pos/components/ProductConfigurationModal/form'
import { FormKeys } from '@/features/pos/components/ProductConfigurationModal/form/constants'
import OptionItem from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem'
import { useUpdateRemovableIngredient } from '@/features/pos/components/ProductConfigurationModal/parts/RemovableIngredientGroup/hooks'
import { FC } from 'react'

interface RemovableIngredientProps {
    id: string
    name: string
}

const RemovableIngredient: FC<RemovableIngredientProps> = ({ id, name }) => {
    const [isRemoved, onChange] = useFormIsIngredientRemoved(id)

    useFormUnregisterField(`${FormKeys.RemovedIngredients}.${id}`)

    const updateIngredient = useUpdateRemovableIngredient(isRemoved, onChange)

    return (
        <OptionItem
            key={id}
            id={id}
            selected={!!isRemoved}
            name={name}
            color="destructive"
            onPress={updateIngredient}
        />
    )
}

export default RemovableIngredient
